export default __webpack_public_path__ + "bf715c4cfa69d60be0e3722c23a1588d.svg";